import { useEffect, useState } from 'react'
import { Text } from '@loadsmart/loadsmart-ui'
import { clearSessionsExcept } from 'common/authManager'
import { getJumpCloudUserManager, JumpCloudSignInState } from 'oidc/jumpcloud'

function JumpCloudLoginCallback() {
  const [signInErrorMessage, setSignInErrorMessage] = useState<string>()

  useEffect(() => {
    getJumpCloudUserManager()
      .signinRedirectCallback()
      .then(signedInJumpCloudUser => {
        clearSessionsExcept('jumpcloud')
        const jumpcloudSignInState = signedInJumpCloudUser.state as JumpCloudSignInState | undefined
        window.location.href = jumpcloudSignInState?.originalUri || '/'
      })
      .catch((signInError: Error) => {
        console.error('JumpCloud sign-in failed', signInError)
        setSignInErrorMessage(signInError.message)
      })
  }, [])

  if (!signInErrorMessage) return null
  return <Text>JumpCloud sign-in failed: {signInErrorMessage}</Text>
}

export default JumpCloudLoginCallback
